import { render, staticRenderFns } from "./DamageForm.vue?vue&type=template&id=5648f9ce&scoped=true"
import script from "./DamageForm.vue?vue&type=script&lang=ts"
export * from "./DamageForm.vue?vue&type=script&lang=ts"
import style0 from "./DamageForm.vue?vue&type=style&index=0&id=5648f9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648f9ce",
  null
  
)

export default component.exports